var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.decoration},[_c('ul',{staticClass:"decoartion__list"},_vm._l((5),function(i){return _c('li',{key:i,attrs:{"data-length":i}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }